import { useCallback, useMemo } from "react";
import { useAuth } from "./usePermissions";
import { isProjectManagerRole } from "../utils/roles";
import { canUpdateOwnedRecord } from "../utils/recordOwnership";

export function useUpdateOwnership() {
  const { user } = useAuth();

  const isProjectManager = useMemo(
    () => isProjectManagerRole(user?.role),
    [user?.role],
  );

  const canUpdateOwnedRecordForUser = useCallback(
    (createdBy, hasUpdatePermission) =>
      canUpdateOwnedRecord(user, hasUpdatePermission, createdBy),
    [user],
  );

  return {
    isProjectManager,
    canUpdateOwnedRecord: canUpdateOwnedRecordForUser,
  };
}
